// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s60z","toggle":"styles_toggle__dVrPb","preview":"styles_preview__2kZ5w"};